import {PrivatePurpose} from "./PrivatePurpose";
//@ts-ignore
import {Nullable} from "@customTypes/CustomUtilityTypes";

export interface RealEstateValuation {
    address: string;
    sqM?: number | null,
    rooms?: number | null,
    typologyID?: number,
    cityID?: number;
    latitude?: number;
    longitude?: number;
    macroTypologyID?: 1;
    sale?: true;
    streetName?: string;
    upper?: number;
    lower?: number;
    estimated?: number;
    conditionType?: number;
    floor?: number | string;
    isSelling?: boolean;
}

export interface PublicValuation {
    publicValuationID?: number;
    email?: string;
    token?: string;
    contactDesired?: Nullable<boolean>;
    privatePurpose?: PrivatePurpose;
    publicUserId?: number;
    realEstateValuation: RealEstateValuation;
    phone?: Nullable<string>;
    name?: string;
    surname?: string;
    userFeedback?: number;
    privateValuation: true;
    valuationSaleTime?: {
        valuationSaleTimeId?: number;
    }
    owner?: Nullable<boolean>;
}

export interface PublicValuationWidget extends PublicValuation {
    conditionTypeId?: number;
    floor?: number
}

export function getBasePublicValuation(): PublicValuation {
    return {
        realEstateValuation: {
            address: "",
            sqM: null,
            rooms: null,
            typologyID: 0,
        },
        contactDesired: null,
        privateValuation: true,
    };
}
